
import { defineComponent, SetupContext } from "vue";
import { BOTTOM_ACTION_TYPE } from "@/types/recipes";
export default defineComponent({
  name: "DetailBottomBar",
  props: {
    stepPrevEnable: {
      type: Boolean,
      default: false
    },
    stepNextEnable: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    const clickItem = (type: string) => {
      if (!props.stepPrevEnable && type == BOTTOM_ACTION_TYPE.PREVIOUS_STEP) {
        return;
      }
      if (!props.stepNextEnable && type == BOTTOM_ACTION_TYPE.NEXT_STEP) {
        return;
      }
      context.emit("click-bottom-item", type);
    };
    const getCursorLeft = () => {
      return props.stepPrevEnable ? require("@/assets/images/cursor_left_bottom.png") : require("@/assets/images/cursor_left_disable.png");
    };
    const getCursorRight = () => {
      return props.stepNextEnable ? require("@/assets/images/cursor_right_bottom.png") : require("@/assets/images/cursor_right_disable.png");
    };
    const styleCursorLeft = () => {
      return props.stepPrevEnable ? { color: "#000000" } : { color: "rgba(0, 0, 0, 0.3)"};
    };
    const styleCursorRight = () => {
      return props.stepNextEnable ? { color: "#000000" } : { color: "rgba(0, 0, 0, 0.3)"};
    };
    return {
      clickItem,
      getCursorLeft,
      getCursorRight,
      styleCursorLeft,
      styleCursorRight,
      BOTTOM_ACTION_TYPE
    };
  }
});
